import { ChevronRight, type LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

interface HomeSectionTitleProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  trailing?: string;
  dark?: boolean;
}

export default function HomeSectionTitle({ icon: Icon, title, subtitle, trailing, dark = true }: HomeSectionTitleProps) {
  return (
    <div className="flex min-w-0 items-center justify-between gap-2">
      <div className="flex min-w-0 items-center gap-2">
        <Icon size={18} className={dark ? 'text-fuchsia-200' : 'text-indigo-500'} />
        <div className="min-w-0">
          <div className={cn('truncate text-lg font-black leading-tight', dark ? 'text-white' : 'text-slate-950')}>{title}</div>
          <div className={cn('truncate text-xs', dark ? 'text-white/58' : 'text-slate-500')}>{subtitle}</div>
        </div>
      </div>
      {trailing && (
        <div className="flex shrink-0 items-center gap-0.5 text-[11px] font-semibold text-slate-400">
          {trailing}
          <ChevronRight size={14} />
        </div>
      )}
    </div>
  );
}
